import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useIsMobile } from '../lib/useIsMobile';
export function Header() {
  const location = useLocation();
  const isMobile = useIsMobile();
  const isActive = (path: string) => location.pathname === path;
  return <header className="fixed top-0 left-0 right-0 z-50 px-4 md:px-8 pt-4 md:pt-6" data-id="element-72">
      <div className="max-w-7xl mx-auto rounded-full bg-white border-4 border-gray-800 px-6 md:px-8 py-4 shadow-[8px_8px_0px_rgba(255,107,107,0.4)]" data-id="element-73">
        <div className="flex items-center justify-between" data-id="element-74">
          {/* Logo */}
          <Link to="/" className="font-poppins font-black text-xl md:text-2xl text-gray-800 hover:scale-110 transition-transform duration-300" data-id="element-75">
            HORIZONIMA
          </Link>

          {/* Center Navigation - Desktop */}
          <nav className="hidden md:flex items-center gap-6" data-id="element-76">
            <Link to="/" className={`text-sm font-bold tracking-wide transition-all duration-300 px-4 py-2 rounded-full ${isActive('/') ? 'bg-gradient-to-r from-coral-500 to-orange-400 text-white scale-110' : 'text-gray-600 hover:text-gray-900 hover:scale-105'}`} data-id="element-77">
              Home
            </Link>
            <Link to="/talent" className={`text-sm font-bold tracking-wide transition-all duration-300 px-4 py-2 rounded-full ${isActive('/talent') ? 'bg-gradient-to-r from-purple-400 to-pink-400 text-white scale-110' : 'text-gray-600 hover:text-gray-900 hover:scale-105'}`} data-id="element-78">
              Creators
            </Link>
            <Link to="/brands" className={`text-sm font-bold tracking-wide transition-all duration-300 px-4 py-2 rounded-full ${isActive('/brands') ? 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white scale-110' : 'text-gray-600 hover:text-gray-900 hover:scale-105'}`} data-id="element-79">
              Brands
            </Link>
          </nav>

          {/* Mobile Navigation */}
          <nav className="flex md:hidden items-center gap-3" data-id="element-80">
            <Link to="/talent" className={`text-xs font-bold px-3 py-2 rounded-full ${isActive('/talent') ? 'bg-purple-400 text-white' : 'text-gray-600'}`} data-id="element-81">
              Creators
            </Link>
            <Link to="/brands" className={`text-xs font-bold px-3 py-2 rounded-full ${isActive('/brands') ? 'bg-yellow-400 text-white' : 'text-gray-600'}`} data-id="element-82">
              Brands
            </Link>
          </nav>

          {/* Contact Button */}
          <a href="mailto:hello@horizonima.com" className="hidden sm:inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-coral-500 to-orange-400 text-white font-bold text-sm border-3 border-gray-800 shadow-[4px_4px_0px_rgba(45,55,72,1)] hover:shadow-[6px_6px_0px_rgba(45,55,72,1)] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all duration-200" data-id="element-83">
            <Mail className="w-4 h-4" data-id="element-84" />
            <span className="hidden md:inline" data-id="element-85">Contact</span>
          </a>
        </div>
      </div>
    </header>;
}